module.exports = {
  TYPE: 'production',
  VEEDGEE_API_BASE_URL: 'https://veedgee-api.vercel.app',
  ANALYTICS: {
    ENABLED: false,
    SRC: 'https://statorama.vercel.app/script.js',
    ID: 'd8c7ac4c-2203-4964-b39b-c9678655fc53'
  },
  SERVICE_WORKERS_ENABLED: true
};
